import { render } from "./ProvisionalEntryView.vue?vue&type=template&id=bf605dea"
import script from "./ProvisionalEntryView.vue?vue&type=script&lang=js"
export * from "./ProvisionalEntryView.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3957297443/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__